module.exports = __webpack_public_path__ + "static/media/add-email.5934b330.svg";